/**
 * api.js — Auth-aware fetch wrapper
 * Adds Authorization header to all requests.
 * Redirects to login on 401 responses.
 */

export function getToken() {
  return localStorage.getItem('korinth_token');
}

export function clearToken() {
  localStorage.removeItem('korinth_token');
}

export async function authFetch(url, options = {}) {
  const token = getToken();
  const headers = { ...options.headers };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (options.body && typeof options.body === 'string') {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';
  }

  const res = await fetch(url, { ...options, headers });

  if (res.status === 401) {
    clearToken();
    window.location.reload();
  }

  return res;
}
